import { defineStore } from 'pinia'

interface TestModeState {
  show: boolean;
  alwaysPerformAssessment: boolean;
  disableRouterGuards: boolean;
  disableMRXErrorChecking: boolean;
  dontSkipPanels: boolean;
  dontFilterResponses: boolean;
  logScores: boolean;
  multipleUploadsOfData: boolean;
  oneClickPanels: boolean;
  showTranslationTokens: boolean;
  showAllAssessments: boolean;
  useSliderForTapper: boolean;
  copyTranslation: boolean;
  showUploadButton: boolean;
}

type TestModeKey = keyof TestModeState

interface ModeEntry {
  name: string;
  value: boolean;
}

export const useTestModeStore = defineStore('testMode', {
  state: (): TestModeState => ({
    show: false,
    alwaysPerformAssessment: false,
    disableRouterGuards: false,
    disableMRXErrorChecking: false,
    dontSkipPanels: false,
    dontFilterResponses: false,
    logScores: false,
    multipleUploadsOfData: false,
    oneClickPanels: false,
    showTranslationTokens: false,
    showAllAssessments: false,
    useSliderForTapper: false,
    copyTranslation: false,
    showUploadButton: false,
  }),

  getters: {
    all(): ModeEntry[] {
      return Object.entries(this.$state).map(([name, value]) => ({
        name,
        value: value as boolean,
      }))
    },

    get: (state) => {
      return (mode: string): boolean => {
        if (mode === 'testing') return state.show
        if (!state.show) return false
        if (!Object.prototype.hasOwnProperty.call(state, mode)) return false
        return state[mode as keyof typeof state]
      }
    },
  },

  actions: {
    set(mode: TestModeKey) {
      if (!(mode in this.$state)) return
      this[mode] = !this[mode]
      if (!this.show) {
        this.$reset()
      }
    },
  },
})
